import React, { useEffect, useState } from 'react';

import _ from 'lodash';
import PropTypes from 'prop-types';

import request from '../../../../utils/request';
import { FieldWrapper } from '../../css';
import { useLocalizedStringsContext } from '../../../../context/LocalizedStringsContext';

import FileUpload from './components/fileUpload';
import FilesList from './components/filesList';

const Attachements = ({ orderData }) => {
  const {
    productInOrderForOptions: { microsoft365, googleWorkspace }
  } = useLocalizedStringsContext();

  const { id: orderId, productInOrderFor } = orderData;
  const [filesList, setFilesList] = useState();

  useEffect(() => {
    request.get(`/orders/${orderId}/files`).then(fileData => {
      const files = _.get(fileData, 'data.rows', []);
      setFilesList(files);
    });
  }, []);

  const addFileToList = newFile => {
    setFilesList([...filesList, newFile]);
  };

  const removeFileFromList = id => {
    const updatedFileList = filesList.filter(file => file.fileId !== id);
    setFilesList(updatedFileList);
  };

  return (
    <FieldWrapper>
      {filesList && filesList.length > 0 && (
        <FilesList
          filesList={filesList}
          orderId={orderId}
          removeFileFromList={removeFileFromList}
        />
      )}
      {[googleWorkspace, microsoft365].includes(productInOrderFor) && (
        <FileUpload addFileToList={addFileToList} orderId={orderId} />
      )}
    </FieldWrapper>
  );
};

Attachements.propTypes = {
  orderData: PropTypes.objectOf(PropTypes.any).isRequired
};

export default Attachements;
